import Logo from "../logo/Logo"
import styles from "./Footer.module.scss"
const Footer = () => {
  return (
      <div className={styles.footer}>
        <Logo size="20px" />
        <small>&copy; 2023 Grahns Trädgård</small>
      </div>
  );
}

export default Footer
